import { useForm } from 'react-hook-form';
import './AddEventForm.scss';
import { yupResolver } from '@hookform/resolvers/yup';
import { FETCH_POLICY, messages } from '../../utils/constants';
import * as yup from "yup";
import dayjs, { Dayjs } from 'dayjs';
import { FC, useEffect, useRef } from 'react';
import { useMutation } from '@apollo/client';
import { CREATE_EVENT, UPDATE_EVENT } from '../../pages/Calendar/api/CalendarQuery';
import ToasterWithMessage from '../toaster';
import { CalendarDataType } from '../../pages/Calendar/Calendar';
import { trackButtonClick } from '../../firebase/analyticsHelper';
import { ButtonClickEvents } from '../../firebase/constants/events';

type AddEventFormType = {
    date: Dayjs | null;
    setDate: (val: Dayjs) => void;
    setOpen: (val: boolean) => void;
    refetch: boolean;
    setRefetch: (val: boolean) => void;
    selectedData: CalendarDataType | undefined;
    setSelectedData: (val: CalendarDataType | undefined) => void;
    setIsEdit: (val: boolean) => void;
    isEdit: boolean;
}

type FormValue = {
    title: string;
    description: string;
}

const schema = yup.object().shape({
    title: yup.string().trim()
    .required(messages.titleRequired)
    // .matches(patterns?.alphaNumericSpace, messages?.title)
    // .matches(patterns?.NotStartWithNumber,messages?.titleNotStartWithNumber)
    // .min(5,messages?.titleLength)
    .max(100, messages?.titleLength),
    description: yup.string().trim().required(messages.desription).max(500, 'Description must be between 1 and 500 characters long'),
});

const AddEventForm: FC<AddEventFormType> = ({ date, setOpen, selectedData, setSelectedData, refetch, setRefetch, setDate, setIsEdit, isEdit }) => {

    const { register, handleSubmit, setValue, watch, reset, formState : {errors} } = useForm<FormValue>({ resolver: yupResolver(schema)});
    const { success, error } = ToasterWithMessage();
    const formContainerRef = useRef<any>();

    const [CreateEvent,{loading:createLoading}] = useMutation(CREATE_EVENT, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: () => {
            setOpen(false);
            setRefetch(!refetch);
            success("Event Created Sucessfully");
            setSelectedData(undefined);
        },
        onError: (err) => {
            error(err?.message);
        }
    })

    const [updateEvent,{loading:updateLoading}] = useMutation(UPDATE_EVENT, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: () => {
            setOpen(false);
            setRefetch(!refetch);
            setIsEdit(false);
            success("Event updated succesfully");
            setSelectedData(undefined);
        },
        onError: (err) => {
            error(err?.message);
        }
    })

    const watchedValues = watch();
    const isFormEmpty = !watchedValues.title && !watchedValues.description;

    useEffect(() => {
        if (!isEdit && selectedData === undefined) {
            formContainerRef?.current?.scrollIntoView({ behavior: "smooth" });
        }
        if (isEdit && selectedData !== undefined) {
            formContainerRef?.current?.scrollIntoView({ behavior: "smooth" });
            setValue('title', selectedData?.eOriginalTitle);
            setValue('description', selectedData?.eDescription);
        }
    }, [ selectedData, isEdit ])
    
    const onSubmit = async (data: FormValue) => {
        trackButtonClick(ButtonClickEvents?.CALENDAR_SAVE, {
            description : "User clicked save button for add event",
            page: 'Calendar'
        });

        const input = {
            eTitle: data?.title?.trim(),
            eDescription: data?.description?.trim(),
            eDate: dayjs(date).format()
        }
        if (selectedData) {
            if (selectedData?.eOriginalTitle === input?.eTitle && selectedData?.eDescription === input?.eDescription && selectedData?.eDate === dayjs(input?.eDate).format("YYYY-MM-DD")) {
                setOpen(false);
                setSelectedData(undefined);
                return;
            }
            updateEvent({
                variables: {
                    eId: selectedData?.eId,
                    input
                }
            })
        } 
        else {
            CreateEvent({
                variables: {
                    input
                }
            })
        }
    }  

    const handleReset = () => {
        trackButtonClick(ButtonClickEvents?.CALENDAR_CLEAR, {
            description : "User clicked clear button in add event",
            page: 'Calendar'
        });
        reset();
        setDate(dayjs());
    }

    const handleClose = () => {
        trackButtonClick(ButtonClickEvents?.CALENDAR_CLOSE, {
            description : "User clicked close button in add event",
            page: 'Calendar'
        });
        setOpen(false);
        setSelectedData(undefined);
    }

    return (
        <div className='addEventContainer'>
            <form id='addEventForm' ref={formContainerRef} onSubmit={handleSubmit(onSubmit)} className='addEventFormContainer'>
                <div className="titleContainer">
                    <div className='date'><span>{ date?.format('dddd DD MMMM YYYY') }</span></div>
                    <input type="text" className="title" placeholder="Event Title" {...register('title')} />
                    {errors?.title && <span className="error">{errors.title.message}</span>}
                </div>
                <div className="descriptionContainer">
                    <textarea className="description" placeholder="Event Description" {...register(`description`)}/>
                    {errors?.description && <span className="error">{errors.description.message}</span>}
                </div>
                <div className="btnContainer">
                    <button type="button" onClick={() => isFormEmpty ? handleClose() : handleReset()} className='clearButtonStyle'>{isFormEmpty ? "Close" : "Clear"}</button>
                    <button type="submit" form='addEventForm' className='okButtonStyle' disabled={createLoading||updateLoading} >Save</button>
                </div>
            </form>
        </div>
    )
}

export default AddEventForm;
